import { Loader, TextButton } from "@anna-money/anna-web-ui";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import type { FC } from "react";
import { Button } from "../../../../components/button/button";
import { ErrorView } from "../../../../components/errorView/errorView";
import type { FormSectionType } from "../../obPaymentPageForm";
import styles from "./submitSection.module.scss";

export const SubmitSection: FC<FormSectionType> = observer(({ form, store }) => {
  const handleRedirect = (): void => {
    window.location.replace("/payment-pages/close");
  };

  if (store.saveStatus === "saving") {
    return <Loader />;
  }

  const scrollToError = (): void => {
    const fieldId = store.getFieldsWithError()[0];
    if (fieldId === undefined) {
      return;
    }

    const field = document.getElementById(fieldId);
    if (field) {
      field.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  const handleSave = async (): Promise<void> => {
    if (form.isValid()) {
      await store.saveData(form.values);
    }

    if (store.getFieldsWithError().length) {
      scrollToError();
    } else {
      await store.runSavedScenario();
      handleRedirect();
    }
  };
  const handlePreview = async (): Promise<void> => {
    if (form.isValid()) {
      await store.saveData(form.values);
    }

    if (store.getFieldsWithError().length) {
      scrollToError();
    } else {
      await store.runPreviewScenario();
      handleRedirect();
    }
  };

  const handleCancel = async (): Promise<void> => {
    await store.runCancelScenario();
    handleRedirect();
  };

  const handleShare = async (): Promise<void> => {
    if (form.isValid()) {
      await store.saveData(form.values);
    }

    if (store.getFieldsWithError().length) {
      scrollToError();
    } else {
      await store.runShareScenario();
      handleRedirect();
    }
  };

  return (
    <div className={styles.buttonBlock}>
      {store.saveStatus === "error" && (
        <div className={styles.errorView}>
          <ErrorView />
        </div>
      )}
      {!!store.getValidationError("token") && (
        <div className={styles.errorView}>
          <ErrorView>Authentication error</ErrorView>
        </div>
      )}
      <Button
        className={classNames(styles.buttonPrimary, styles.buttonSave)}
        disabled={form.hasErrors || !!store.getValidationError("imageSize")}
        onClick={() => {
          void handleShare();
        }}
      >
        Share payment link
      </Button>
      <Button
        className={classNames(styles.buttonSave)}
        disabled={form.hasErrors || !!store.getValidationError("imageSize")}
        onClick={() => {
          void handleSave();
        }}
        type="secondary"
      >
        Save and close
      </Button>
      <Button
        className={classNames(styles.buttonSave)}
        disabled={form.hasErrors || !!store.getValidationError("imageSize")}
        onClick={() => {
          void handlePreview();
        }}
        type="secondary"
      >
        Preview page
      </Button>

      <TextButton
        size="l"
        className={styles.buttonCancel}
        onClick={() => {
          void handleCancel();
        }}
        text="Cancel"
      />
    </div>
  );
});
